module.exports = __webpack_public_path__ + "static/media/logo_mf.0dde24dc.jpg";